import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentConnectionRow } from "../types";

const VCSAgentPoolAgentsTableDropdownCell = ({
  ...cellProps
}: TableSimpleCellProps<VcsAgentConnectionRow>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default VCSAgentPoolAgentsTableDropdownCell;
